<template>
	<div class="display-flex flex-wrap flex-column" style="position: relative">
		<HelpBox class="flex-1" :backgroundUrl="backgroundUrl" @click="askPlyForHelp">
			<template #text>
				<span>
					Ask for help<br />from the Ply team
					<span class="small-text">(it's free)</span>
				</span>
			</template>
		</HelpBox>
		<div class="width-100 position-absolute message">
			<span>Your idea will be shared with the Ply team</span>
		</div>
	</div>
</template>

<script>
import IntercomService from '@/utils/IntercomService';
import HelpBox from './HelpBox.vue';
import backgroundUrl from './assets/ply-team.png';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service.js';

export default {
	name: 'AskPlyHelpBox',
	props: { idea: { type: Object } },
	components: { HelpBox },
	computed: {
		ideaTitle() {
			let res = '';
			InspirationCenterService.formatContentWithServiceDetails(this.idea.title, this.idea.params, []).forEach((item) => {
				if (item.text) {
					res += item.text;
				}
			});
			return res;
		},
	},
	methods: {
		askPlyForHelp() {
			IntercomService.showNewMessage(`I need help with my idea [${this.ideaTitle}]`);
			this.$emit('click');
		},
	},
	data() {
		return {
			backgroundUrl,
		};
	},
};
</script>

<style lang="scss" scoped>
.small-text {
	font-size: 14px;
}
.message {
	bottom: -25px;
	span {
		font-size: 14px;
		font-weight: 400;
		opacity: 0.5;
	}
}
</style>
